import firebase from 'firebase/app';
import "firebase/auth";
import "firebase/storage";
import "firebase/database";
import "firebase/functions";


const config = {
    apiKey: "AIzaSyDZsn4b1aXTdxsR_pqWM2PPYzIgSxTURd8",
    authDomain: "brf-hasthagen.firebaseapp.com",
    projectId: "brf-hasthagen",
    storageBucket: "brf-hasthagen.appspot.com",
    messagingSenderId: "709601029859",
    appId: "1:709601029859:web:202ae62cb4388ade051fd6",
    measurementId: "G-JP8PZXG6ZR"
};

var fireClone = firebase.initializeApp(config,"clone");
export default fireClone;
